var _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivechatLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93141 3.75C5.0698 3.75 2.75 6.0698 2.75 8.93141C2.75 10.8606 3.80402 12.5446 5.3712 13.4373L5.75 13.6531V15.9499L7.65316 14.1128H11.2042C14.0658 14.1128 16.3856 11.793 16.3856 8.93141C16.3856 6.0698 14.0658 3.75 11.2042 3.75H7.93141ZM1.25 8.93141C1.25 5.24137 4.24137 2.25 7.93141 2.25H11.2042C14.8942 2.25 17.8856 5.24137 17.8856 8.93141C17.8856 12.6215 14.8942 15.6128 11.2042 15.6128H8.25902L6.36813 17.4381C5.57453 18.2041 4.25 17.6417 4.25 16.5387V14.5079C2.44364 13.3131 1.25 11.2621 1.25 8.93141Z",
    fill: "#818181"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.56528,
    cy: 8.93086,
    rx: 1.02267,
    ry: 1.02266,
    fill: "#818181"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.70248,
    cy: 8.93086,
    rx: 1.02267,
    ry: 1.02266,
    fill: "#818181"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4297,
    cy: 8.93086,
    rx: 1.02267,
    ry: 1.02266,
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechatLine);
export default __webpack_public_path__ + "clientapp/media/livechat_line.9dc28735.svg";
export { ForwardRef as ReactComponent };